import { Component, OnInit, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { DisabilitySurvey } from '@ascschool/model/survey/disability-survey';
import { SurveyPublicService } from '@ascschool/services/public/survey-public.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-phieu-hoi-nkt',
  templateUrl: './phieu-hoi-nkt.component.html',
  styleUrls: ['./phieu-hoi-nkt.component.scss']
})
export class PhieuHoiNktComponent implements OnInit {
  @ViewChildren("label") labelElement;
  disabilitySurvey = new DisabilitySurvey;
  isCheckValidate = true;
  day: number;
  month: number;
  year: number
  getFolkACFn: (value: any) => Observable<any>;
  FolkSubscription: any;
  FolkControl = new FormControl();
  yearNow = (new Date()).getFullYear();
  getDistrictACFn: (value: any) => Observable<any>;
  DistrictSubscription: any;
  DistrictControl = new FormControl();

  getProvinceACFn: (value: any) => Observable<any>;
  ProvinceSubscription: any;
  ProvinceControl = new FormControl();

  getWardACFn: (value: any) => Observable<any>;
  WardSubscription: any;
  WardControl = new FormControl();

  getDisTypeOfDisabilitysACFn: (value: any) => Observable<any>;
  disTypeOfDisabilitysSubscription: any;
  disTypeOfDisabilitysControl = new FormControl();

  getLevelACFn: (value: any) => Observable<any>;
  LevelSubscription: any;
  LevelControl = new FormControl();

  getDisStudyModeACFn: (value: any) => Observable<any>;
  disStudyModeSubscription: any;
  disStudyModeControl = new FormControl();

  getSchoolLevelACFn: (value: any) => Observable<any>;
  SchoolLevelSubscription: any;
  SchoolLevelControl = new FormControl();

  getQualificationACFn: (value: any) => Observable<any>;
  QualificationSubscription: any;
  QualificationControl = new FormControl();

  getEmploymentStatusACFn: (value: any) => Observable<any>;
  EmploymentStatusSubscription: any;
  EmploymentStatusControl = new FormControl();

  getEducationLevelACFn: (value: any) => Observable<any>;
  EducationLevelSubscription: any;
  EducationLevelControl = new FormControl();

  getMaritalStatusACFn: (value: any) => Observable<any>;
  MaritalStatusSubscription: any;
  MaritalStatusControl = new FormControl();

  getCaDisEducationalStatusessACFn: (value: any) => Observable<any>;
  caDisEducationalStatusesSubscription: any;
  caDisEducationalStatusesControl = new FormControl();

  getCaregiverACFn: (value: any) => Observable<any>;
  CaregiverSubscription: any;
  CaregiverControl = new FormControl();

  getLivingConditionsACFn: (value: any) => Observable<any>;
  LivingConditionsSubscription: any;
  LivingConditionsControl = new FormControl();

  getModesOfEducationsACFn: (value: any) => Observable<any>;
  ModesOfEducationsSubscription: any;
  ModesOfEducationsControl = new FormControl();

  // getPublicCommunityCoordinations: (value: any) => Observable<any>;
  PublicCommunityCoordinationsSubscription: any;
  PublicCommunityCoordinationsControl = new FormControl();

  listStatuses = [];
  listNeedOfDisabilities = [];
  listEmploymentStatus = [];
  listEducationalSupports = [];
  listDisabilityPolicy = [];
  listPublicCommunityCoordinations = [];
  listLocalGovernmentCoordinations = [];
  listInformationSources = [];
  inputCode: any = [];
  listRequired  = [
    { name :'infoProvider', constraint: null},
    { name :'levelId', constraint: null},
    { name :'fullName', constraint: null},
    { name :'yearOfBirth', constraint: null},
    { name :'gender', constraint: null},
    { name :'folkId', constraint: null},
    { name :'provinceId', constraint: null},
    { name :'disDisabilityCertificateType', constraint: null},
    { name :'typeOfDisabilityId', constraint: null},
    { name :'supportedEducation', constraint: null},
    { name :'educationalStatusId', constraint: null},
    { name :'employmentStatusId', constraint: null},
    { name :'maritalStatusId', constraint: null},
    { name :'caregiverId', constraint: null},
    { name :'livingConditionId', constraint: null},
    { name :'listStudentSurveyLevelOfDevelopment', constraint: null},
    { name :'listStudentSurveyDisabilityPolicy', constraint: 'understandDisabilityPolicy'},
    { name :'listStudentSurveyInformationSource', constraint: null},
    { name :'listStudentSurveyInterventionStatus', constraint: 'interventioned'},
  ];
  constructor(
    private msg: NzMessageService,
    private publicService: SurveyPublicService,
    public utilService: UtilsService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.loadFolk();
    setTimeout(() => {
      this.FolkControl.setValue({id: 1027, folkName: "Kinh"});
      this.TutorFolkControl.setValue({id: 1027, folkName: "Kinh"});
    }, 100);
    this.loadProvince();
    this.loadDisTypeOfDisabilitys();
    this.loadLevel();
    this.loadDisStudyMode();
    this.loadEmploymentStatus();
    this.loadMaritalStatus();
    this.loadCaDisEducationalStatuses();
    this.loadCaregiver();
    this.getNeedOfDisabilities();
    this.getEmploymentStatus();
    this.loadPublicLivingConditions();
    this.getEducationalSupports();
    this.loadModesOfEducations();
    this.getDisabilityPolicy();
    this.getPublicCommunityCoordinations();
    this.getPublicLocalGovernmentCoordinations();
    this.getInformationSources();
    this.getStatuses();
    this.getLevelOfDevelopmentTypes();
    this.loadEducationLevel();
    this.loadSchoolLevel();
    //Tutor//////////////////////////////////////////
    this.loadRelationship();
    this.loadTutorFolk();
    this.loadtutorEducationLevel();
    this.loadTutorModesOfEducations();
    this.getTutorTrainingAndRetrainingType();
    this.disabilitySurvey.tutorGender = 1;
    this.getTutorTrainingAndRetrainings();
    this.getSkillTypes();
    /////////////////////////////////////////////////
    this.disabilitySurvey.gender = 1;
    this.disabilitySurvey.infoProvider = 1;
    this.disabilitySurvey.disDisabilityCertificateType = 1;
    this.disabilitySurvey.supportedEducation = true;
    this.disabilitySurvey.disDisabilityCertificateType = 1;
    this.disabilitySurvey.interventioned = false;
    this.disabilitySurvey.understandDisabilityPolicy = false;
    this.disabilitySurvey.tutorUnderstandDisabilityPolicy = false;
    this.disabilitySurvey.communityCoordination = false;
    this.disabilitySurvey.localGovernmentCoordination = false;
  }
  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value != 'string') return control.value.id;
    return '';
  }
  loadFolk() {
    this.getFolkACFn = (value: any) => this.publicService.getPublicFolks({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.folkName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.FolkSubscription) this.FolkSubscription = this.FolkControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'folkId', this.FolkControl.value);
    });
  }
  changeFolk(control: FormControl) {
    this.FolkControl = control;
  }
  loadProvince() {
    this.getProvinceACFn = (value: any) => this.publicService.getPublicProvinces({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.ProvinceSubscription) this.ProvinceSubscription = this.ProvinceControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'provinceId', this.ProvinceControl.value);
    });
  }
  changeProvince(control: FormControl) {
    this.ProvinceControl = control;
    this.loadDistrict();
    this.DistrictControl.setValue(null);
  }

  loadDistrict() {
    this.getDistrictACFn = (value: any) => this.publicService.getPublicDistricts({ searchTerm: value, ProvinceId: this.valueIfHas(this.ProvinceControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.DistrictSubscription) this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'districtId', this.DistrictControl.value);
    });
  }
  changeDistrict(control: FormControl) {
    this.DistrictControl = control;
    this.loadWard();
    this.WardControl.setValue(null);
  }

  loadWard() {
    this.getWardACFn = (value: any) => this.publicService.getPublicWards({ searchTerm: value, DistrictId: this.valueIfHas(this.DistrictControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.wardName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.WardSubscription) this.WardSubscription = this.WardControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'wardId', this.WardControl.value);
    });
  }
  changeWard(control: FormControl) {
    this.WardControl = control;
  }
  loadDisTypeOfDisabilitys() {
    // tslint:disable-next-line: max-line-length
    this.getDisTypeOfDisabilitysACFn = (value: any) => this.publicService.getPublicTypeOfDisabilitys({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.typeOfDisabilityName, isRequiredNote: x.isRequiredNote })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.disTypeOfDisabilitysSubscription) { this.disTypeOfDisabilitysSubscription = this.disTypeOfDisabilitysControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'typeOfDisabilityId', this.disTypeOfDisabilitysControl.value);
    });
    }
  }
  isRequiredNoteDisTypeOfDisability: boolean = false;
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisTypeOfDisabilitysACFn(control: FormControl) {
    this.disTypeOfDisabilitysControl = control;
    this.isRequiredNoteDisTypeOfDisability = control.value.isRequiredNote;
    this.disabilitySurvey.typeOfDisabilityNote = '';
  }
  loadLevel() {
    // tslint:disable-next-line: max-line-length
    this.getLevelACFn = (value: any) =>
      this.publicService.getPublicLevels({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
        // tslint:disable-next-line: max-line-length
        map((resp) =>
          resp.results.length > 0
            ? resp.results.map((x) => ({ id: x.id, text: x.levelName }))
            : [{ id: null, text: 'Không có dữ liệu' }]
        )
      );
    // tslint:disable-next-line: max-line-length
    if (!this.LevelSubscription) {
      this.LevelSubscription = this.LevelControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'levelId', this.LevelControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeLevelACFn(control: FormControl) {
    this.LevelControl = control;
  }
  loadDisStudyMode() {
    // tslint:disable-next-line: max-line-length
    this.getDisStudyModeACFn = (value: any) =>
      this.publicService
        .getPublicStudyModes({ searchTerm: value, PageIndex: 1, PageSize: 100 })
        .pipe(
          // tslint:disable-next-line: max-line-length
          map((resp) =>
            resp.results.length > 0
              ? resp.results.map((x) => ({ id: x.id, text: x.name }))
              : [{ id: null, text: 'Không có dữ liệu' }]
          )
        );
    // tslint:disable-next-line: max-line-length
    if (!this.disStudyModeSubscription) {
      this.disStudyModeSubscription = this.disStudyModeControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(
          this.disabilitySurvey,
          'studyModeId',
          this.disStudyModeControl.value
        );
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisStudyMode(control: FormControl) {
    this.disStudyModeControl = control;
  }
  loadEducationLevel() {
    this.getEducationLevelACFn = (value: any) => this.publicService.getPublicEducationLevels({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.EducationLevelSubscription) this.EducationLevelSubscription = this.EducationLevelControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'educationLevelId', this.EducationLevelControl.value);
    });
  }
  changeEducationLevel(control: FormControl) {
    this.EducationLevelControl = control;
  }

  loadSchoolLevel() {
    this.getSchoolLevelACFn = (value: any) => this.publicService.getPublicSchoolLevels({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.schoolLevelName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.SchoolLevelSubscription) this.SchoolLevelSubscription = this.SchoolLevelControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'schoolLevelId', this.SchoolLevelControl.value);
    });
  }
  changeSchoolLevel(control: FormControl) {
    this.SchoolLevelControl = control;
  }

  loadEmploymentStatus() {
    this.getEmploymentStatusACFn = (value: any) => this.publicService.getPublicEmploymentStatus({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.EmploymentStatusSubscription) this.EmploymentStatusSubscription = this.EmploymentStatusControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'employmentStatusId', this.EmploymentStatusControl.value);
    });
  }
  changeEmploymentStatus(control: FormControl) {
    this.EmploymentStatusControl = control;
  }
  loadMaritalStatus() {
    this.getMaritalStatusACFn = (value: any) => this.publicService.getPublicMaritalStatus({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.MaritalStatusSubscription) this.MaritalStatusSubscription = this.MaritalStatusControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'maritalStatusId', this.MaritalStatusControl.value);
    });
  }
  changeMaritalStatus(control: FormControl) {
    this.MaritalStatusControl = control;
  }
  loadCaDisEducationalStatuses() {
    // tslint:disable-next-line: max-line-length
    this.getCaDisEducationalStatusessACFn = (value: any) => this.publicService.getPublicStatuses({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name, code: x.code })) : [{ id: null, text: 'Không có dữ liệu', code: null }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.caDisEducationalStatusesSubscription) { this.caDisEducationalStatusesSubscription = this.caDisEducationalStatusesControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'educationalStatusId', this.caDisEducationalStatusesControl.value);
    });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeCaDisEducationalStatuses(control: FormControl) {
    this.caDisEducationalStatusesControl = control;
  }
  loadCaregiver() {
    this.getCaregiverACFn = (value: any) => this.publicService.getPublicDisCaregivers({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name, isRequiredNote: x.isRequiredNote })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.CaregiverSubscription) this.CaregiverSubscription = this.CaregiverControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'caregiverId', this.CaregiverControl.value);
    });
  }
  isRequiredDisCaregivers = false;
  changeCaregiver(control: FormControl) {
    this.CaregiverControl = control;
    this.isRequiredDisCaregivers = control.value.isRequiredNote;
    this.disabilitySurvey.caregiverNote = '';
  }
  loadPublicLivingConditions() {
    this.getLivingConditionsACFn = (value: any) => this.publicService.getPublicLivingConditions({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.LivingConditionsSubscription) this.LivingConditionsSubscription = this.LivingConditionsControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'livingConditionId', this.LivingConditionsControl.value);
    });
  }
  changeLivingConditions(control: FormControl) {
    this.LivingConditionsControl = control;
  }
  loadModesOfEducations() {
    this.getModesOfEducationsACFn = (value: any) => this.publicService.getPublicModesOfEducations({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.ModesOfEducationsSubscription) this.ModesOfEducationsSubscription = this.ModesOfEducationsControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'modesOfEducationId ', this.ModesOfEducationsControl.value);
    });
  }

  changeModesOfEducations(control: FormControl) {
    this.ModesOfEducationsControl = control;
  }
  getStatuses(){
    this.publicService.getPublicStatuses({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listStatuses = res.results;
    });
  }
  getNeedOfDisabilities(){
    this.publicService.getPublicInterventionStatuss({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listNeedOfDisabilities = res.results.map(x => ({ value: x.id, label: x.name, checked: false, isRequiredNote: x.isRequiredNote  }));
    });
  }

  getEmploymentStatus(){
    this.publicService.getPublicEmploymentStatus({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listEmploymentStatus = res.results;
    });
  }
  getEducationalSupports(){
    this.publicService.getPublicEducationalSupports({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listEducationalSupports = res.results.map(x => ({ value: x.id, name: x.name, checked: false, isApprentice: x.isApprentice, isEarlyIntervention: x.isEarlyIntervention, isEducationFacilitiesEquipment: x.isEducationFacilitiesEquipment, isRequiredNote: x.isRequiredNote }));
      this.listTutorEducationalSupports = res.results.map(x => ({ value: x.id, name: x.name, checked: false, isApprentice: x.isApprentice, isEarlyIntervention: x.isEarlyIntervention, isEducationFacilitiesEquipment: x.isEducationFacilitiesEquipment, isRequiredNote: x.isRequiredNote }));
    });
  }
  getDisabilityPolicy(){
    this.publicService.getPublicDisabilityPolicy({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listDisabilityPolicy = res.results.map(x => ({ value: x.id, name: x.name, checked: false, isRequiredNote: x.isRequiredNote }));
    });
    this.publicService.getPublicDisabilityPolicy({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listTutorDisabilityPolicy = res.results.map(x => ({ value: x.id, name: x.name, checked: false, isRequiredNote: x.isRequiredNote }));
    });
  }
  getInformationSources(){
    this.publicService.getPublicInformationSources({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listInformationSources = res.results.map(x => ({ value: x.id, name: x.name, checked: false, isRequiredNote: x.isRequiredNote }));
      this.listTutorInformationSources = res.results.map(x => ({ value: x.id, name: x.name, checked: false, isRequiredNote: x.isRequiredNote }));
    });
  }
  getPublicCommunityCoordinations(){
    this.publicService.getPublicCommunityCoordinations({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listPublicCommunityCoordinations = res.results.map(x => ({ value: x.id, name: x.name, checked: false }));
      this.listPublicTutorCommunityCoordinations = res.results.map(x => ({ value: x.id, name: x.name, checked: false }));
    });
  }
  getPublicLocalGovernmentCoordinations(){
    this.publicService.getPublicLocalGovernmentCoordinations({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listLocalGovernmentCoordinations = res.results.map(x => ({ value: x.id, name: x.name, checked: false }));
      this.listTutorLocalGovernmentCoordinations = res.results.map(x => ({ value: x.id, name: x.name, checked: false }));
    });
  }
  changeOneCheckNOD(index){
    this.listNeedOfDisabilities[index].checked = !this.listNeedOfDisabilities[index].checked;
  }
  changeOneCheckES(event,index){
    this.listEducationalSupports[index].checked = event;
    if(this.listEducationalSupports[index].isEarlyIntervention &&  !this.listEducationalSupports[index].checked){
      this.ModesOfEducationsControl.setValue(null);

    }else if(this.listEducationalSupports[index].isApprentice &&  !this.listEducationalSupports[index].checked){
      this.disabilitySurvey.apprenticeNote = null;

    }else if(this.listEducationalSupports[index].isRequiredNote &&  !this.listEducationalSupports[index].checked){
      this.disabilitySurvey.educationalSupportNote = '';

    }else if(this.listEducationalSupports[index].isEducationFacilitiesEquipment &&  !this.listEducationalSupports[index].checked){
      this.disabilitySurvey.educationFacilitiesEquipment = '';
      this.disabilitySurvey.personalVehicle = '';
    }
  }
  changeOneCheckInformationSources(event, index){
    this.listInformationSources[index].checked = event;
    if(this.listInformationSources[index].isRequiredNote &&  !this.listInformationSources[index].checked){
      this.disabilitySurvey.informationSourceNote = '';
    }
  }
  understandDisabilityPolicyChange(event){
    this.disabilitySurvey.understandDisabilityPolicy = event;
    if(this.disabilitySurvey.understandDisabilityPolicy === false){
      this.listDisabilityPolicy.forEach(element => {
        element.checked = false;
      });
    }
    this.disabilitySurvey.disabilityPolicyNote = '';
  }
  listLevelOfDevelopmentTypes = [];
  listlvDv =[];
  getLevelOfDevelopmentTypes(){
    this.publicService.getPublicLevelOfDevelopmentTypes({ PageIndex: 1, PageSize: 100 }).subscribe(res => {


      this.listLevelOfDevelopmentTypes = res.datas;
    });
  }
  submitted  : boolean = false;
  update(){
    this.disabilitySurvey.listStudentSurveyInterventionStatus = [];
    this.disabilitySurvey.listStudentSurveyEducationSupport = [];
    this.disabilitySurvey.listStudentSurveyDisabilityPolicy = [];
    this.disabilitySurvey.listStudentSurveyInformationSource = [];
    this.disabilitySurvey.listStudentSurveyTutorTrainingAndRetrainingTypes = this.listTutorTrainingAndRetrainingType.map(
      x =>({studentSurveyId : 0, tutorTrainingAndRetrainingTypeId: x.tutorTrainingAndRetrainingTypeId, note: x.note}));
    //list B
    let list = [];
    if(this.listlvDv.length >0){
      for(let i in this.listLevelOfDevelopmentTypes){
        if(this.listlvDv[i]){
          list.push({LevelOfDevelopmentId : this.listlvDv[i] , LevelOfDevelopmentTypeId : this.listLevelOfDevelopmentTypes[i].id});
        }
      }
      this.disabilitySurvey.listStudentSurveyLevelOfDevelopment = list;
    }
    this.listNeedOfDisabilities.forEach(element =>{
      if(element.checked){
        this.disabilitySurvey.listStudentSurveyInterventionStatus.push(element.value);
      }
    });
    this.listDisabilityPolicy.forEach(element =>{
      if(element.checked){
        this.disabilitySurvey.listStudentSurveyDisabilityPolicy.push(element.value);
      }
    });
    this.listEducationalSupports.forEach(element =>{
      if(element.checked){
        this.disabilitySurvey.listStudentSurveyEducationSupport.push(element.value);
      }
    });
    this.listInformationSources.forEach(element =>{
      if(element.checked){
        this.disabilitySurvey.listStudentSurveyInformationSource.push(element.value);
      }
    });

    //tutor///////////////////////////////////////
    this.disabilitySurvey.listStudentSurveyTutorDisabilityPolicy = [];
    this.disabilitySurvey.listStudentSurveyTutorInformationSources = [];
    this.disabilitySurvey.listStudentSurveyTutorEducationSupports = [];
    this.listTutorDisabilityPolicy.forEach(element =>{
      if(element.checked){
        this.disabilitySurvey.listStudentSurveyTutorDisabilityPolicy.push(element.value);
      }
    });
    this.listTutorInformationSources.forEach(element =>{
      if(element.checked){
        this.disabilitySurvey.listStudentSurveyTutorInformationSources.push(element.value);
      }
    });
    this.listTutorEducationalSupports.forEach(element =>{
      if(element.checked){
        this.disabilitySurvey.listStudentSurveyTutorEducationSupports.push(element.value);
      }
    });
    this.disabilitySurvey.listStudentSurveyTutorTrainingAndRetrainings = [];
    this.listTutorTrainingAndRetraining.forEach(element =>{
      if(element.checked){
        this.disabilitySurvey.listStudentSurveyTutorTrainingAndRetrainings.push(element.id);
      }
    });
    this.disabilitySurvey.listStudentSurveyTutorSkillTypes = this.listSkillTypes.map(x =>({skillTypeId: x.skillTypeId, hasBeenTrained : x.hasBeenTrained,isDemand: x.isDemand, studentSurveyId: 0}));
    /////////////////////////////////////////////
    if(this.checkValid(this.disabilitySurvey, this.listRequired, this.labelElement)){
      this.submitted = true;
      this.publicService.AddStudentSurvey(this.disabilitySurvey).subscribe((res) => {
        if (res.statusCode === 0){
          this.submitted = false;
          this.msg.success('Thành công');
          this.router.navigate(['/camOnKhaoSat',1]);
        }else{
          this.msg.warning(res.message);
        }
      }, error => {
        this.msg.error('lỗi: ' + error.error.Message);
      });
    }
  }


  interventionedChange(event){
    this.disabilitySurvey.interventioned = event;
    if( this.disabilitySurvey.interventioned === false){
      this.listNeedOfDisabilities.forEach(element => {
        element.checked = false;
      });
    }
    this.disabilitySurvey.interventionNote = '';
  }
  governmentCoordinationChange(event){
    this.disabilitySurvey.localGovernmentCoordination = event;
  }
  checkValid(data, listRequired, labelElement){
    let count = 0;
    let keyError = [];
    listRequired.forEach(
      element =>{
        let key = element.name;
        let constraint = element.constraint;
        if((typeof(data[key]) !== 'undefined') && (data[key] !== null)){
        }else{
          count++;
          keyError.push(key);
        }
        if(constraint){
          if(Array.isArray(data[key]) && data[key].length === 0){
            if(data[constraint]){
              count++;
              keyError.push(key);
            }
          }
        }else{
          if(Array.isArray(data[key]) && data[key].length === 0){
            count++;
            keyError.push(key);
          }
        }
    });
    if(count > 0){
      this.utilService.notifyValidateSurvey(keyError,labelElement);
      return false;
    }else{
      return true;
    }
  }
  educationalStatusIdChange(event){
    this.disabilitySurvey.educationalStatusId = event;
    this.disabilitySurvey.studyingClassYear= '';
    this.disabilitySurvey.droppedOutClassYear= '';
    this.disabilitySurvey.notYetLearnedNote= '';
    this.disabilitySurvey.droppedOutNote= '';
    this.disStudyModeControl.setValue(null);
    this.EducationLevelControl.setValue(null);
  }
  needOfDisabilitiesCheckedChange(event,index){
    this.listNeedOfDisabilities[index].checked = event;
    if(this.listNeedOfDisabilities[index].isRequiredNote &&  !this.listNeedOfDisabilities[index].checked){
      this.disabilitySurvey.interventionNote = '';
    }
  }
  TutorDisabilityPolicyCheckedChange(event, item, index){
    this.listTutorTrainingAndRetrainingType[index].checked = event;
    this.listTutorTrainingAndRetrainingType[index].tutorTrainingAndRetrainingTypeId = item.id;
  }
  disabilityPolicyCheckedChange(event, index){
    this.listDisabilityPolicy[index].checked = event;
    if(this.listDisabilityPolicy[index].isRequiredNote &&  !this.listDisabilityPolicy[index].checked){
      this.disabilitySurvey.disabilityPolicyNote = '';
    }
  }
  tutordisabilityPolicyCheckedChange(event, index){
    this.listTutorDisabilityPolicy[index].checked = event;
    if(this.listTutorDisabilityPolicy[index].isRequiredNote &&  !this.listTutorDisabilityPolicy[index].checked){
      this.disabilitySurvey.tutorDisabilityPolicyNote = '';
    }
  }
  tutorTrainingAndRetrainingTypeNoteChange(event, index){
    this.listTutorTrainingAndRetrainingType[index].note = event;
  }
  employmentStatusIdChange(event){
    this.disabilitySurvey.employmentStatusId = event;
    this.disabilitySurvey.notWorkingNote = '';
    this.disabilitySurvey.quitJobNote= '';
    this.disabilitySurvey.particularJob= '';
    this.disabilitySurvey.averageIncome= null;
  }

    //Người giám hộ ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    isRequiredTutorEducationLevel = false;
    getTutorFolkACFn: (value: any) => Observable<any>;
    TutorFolkSubscription: any;
    TutorFolkControl = new FormControl();
    getRelationshipACFn: (value: any) => Observable<any>;
    RelationshipSubscription: any;
    RelationshipControl = new FormControl();
    getTutorEducationLevelACFn: (value: any) => Observable<any>;
    tutorEducationLevelSubscription: any;
    tutorEducationLevelControl = new FormControl();
    getTutorModesOfEducationsACFn: (value: any) => Observable<any>;
    TutorModesOfEducationsSubscription: any;
    TutorModesOfEducationsControl = new FormControl();


    loadRelationship() {
      this.getRelationshipACFn = (value: any) => this.publicService.getPublicRelationships({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
        map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
      );
      if (!this.RelationshipSubscription) this.RelationshipSubscription = this.RelationshipControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'tutorRelationshipId', this.RelationshipControl.value);
      });
    }
    changeRelationship(control: FormControl) {
      this.RelationshipControl = control;
    }
    loadTutorFolk() {
      this.getTutorFolkACFn = (value: any) => this.publicService.getPublicFolks({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
        map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.folkName })) : [{ id: null, text: 'Không có dữ liệu' }])
      );
      if (!this.TutorFolkSubscription) this.TutorFolkSubscription = this.TutorFolkControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'tutorFolkId', this.FolkControl.value);
      });
    }
    changeTutorFolk(control: FormControl) {
      this.TutorFolkControl = control;
    }
    loadtutorEducationLevel() {
      this.getTutorEducationLevelACFn = (value: any) => this.publicService.getPublicEducationLevels({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
        map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name, typeOfDisabilityNote: x.typeOfDisabilityNote })) : [{ id: null, text: 'Không có dữ liệu' }])
      );
      if (!this.tutorEducationLevelSubscription) this.tutorEducationLevelSubscription = this.tutorEducationLevelControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'tutorEducationLevelId', this.tutorEducationLevelControl.value);
      });
    }
    changeTutorEducationLevel(control: FormControl) {
      this.tutorEducationLevelControl = control;
      this.isRequiredTutorEducationLevel = control.value.isRequiredNote;
      this.disabilitySurvey.tutorEducationLevelOther = '';
    }
    loadTutorModesOfEducations() {
      this.getTutorModesOfEducationsACFn = (value: any) => this.publicService.getPublicModesOfEducations({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
        map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
      );
      if (!this.TutorModesOfEducationsSubscription) this.TutorModesOfEducationsSubscription = this.TutorModesOfEducationsControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.disabilitySurvey, 'tutorModesOfEducationId', this.TutorModesOfEducationsControl.value);
      });
    }

    changeTutorModesOfEducations(control: FormControl) {
      this.TutorModesOfEducationsControl = control;
    }
    listTutorTrainingAndRetrainingType = [];
    getTutorTrainingAndRetrainingType(){
      this.publicService.getPublicCaTutorTrainingAndRetrainingTypes({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
        this.listTutorTrainingAndRetrainingType = res.results.map(x =>({tutorTrainingAndRetrainingTypeId: x.id, checked : false, note: '', name: x.name}));
      });
    }
    listTutorTrainingAndRetraining = [];
    getTutorTrainingAndRetrainings(){
      this.publicService.getPublicCaTutorTrainingAndRetrainings({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
        this.listTutorTrainingAndRetraining = res.results.map(x =>({id: x.id, checked : false, name: x.name}));
      });
    }
    listSkillTypes = [];
    getSkillTypes(){
      this.publicService.getPublicSkillTypes({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
        this.listSkillTypes = res.results.map(x =>({skillTypeId: x.id, hasBeenTrained : false,isDemand: false, name: x.name}));
      });
    }

    //Model change////////////////
    listTutorDisabilityPolicy = [];
    tutorUnderstandDisabilityPolicyChange(event){
      this.disabilitySurvey.tutorUnderstandDisabilityPolicy = event;
      if(this.disabilitySurvey.tutorUnderstandDisabilityPolicy === false){
        this.listTutorDisabilityPolicy.forEach(element => {
          element.checked = false;
        });
      }
      this.disabilitySurvey.tutorDisabilityPolicyNote = '';
    }
    tutorDisabilityPolicyCheckedChange(event,index){
      this.listTutorDisabilityPolicy[index].checked = event;
      if(this.listTutorDisabilityPolicy[index].isRequiredNote &&  !this.listTutorDisabilityPolicy[index].checked){
        this.disabilitySurvey.tutorDisabilityPolicyNote = '';
      }
    }
    listTutorInformationSources = [];
    changeOneCheckTutorInformationSources(event, index){
      this.listTutorInformationSources[index].checked = event;
      if(this.listTutorInformationSources[index].isRequiredNote &&  !this.listTutorInformationSources[index].checked){
        this.disabilitySurvey.tutorInformationSourceNote = '';
      }
    }
    listPublicTutorCommunityCoordinations = [];
    listTutorLocalGovernmentCoordinations = [];
    listTutorEducationalSupports = [];
    changeOneCheckTutorES(event,index){
      this.listTutorEducationalSupports[index].checked = event;
      if(this.listTutorEducationalSupports[index].isEarlyIntervention &&  !this.listTutorEducationalSupports[index].checked){
        this.TutorModesOfEducationsControl.setValue(null);

      }else if(this.listTutorEducationalSupports[index].isApprentice &&  !this.listTutorEducationalSupports[index].checked){
        this.disabilitySurvey.tutorApprenticeNote = null;

      }else if(this.listTutorEducationalSupports[index].isRequiredNote &&  !this.listTutorEducationalSupports[index].checked){
        this.disabilitySurvey.tutorEducationalSupportNote = '';

      }else if(this.listTutorEducationalSupports[index].isEducationFacilitiesEquipment &&  !this.listTutorEducationalSupports[index].checked){
        this.disabilitySurvey.tutorEducationFacilitiesEquipment = '';
        this.disabilitySurvey.tutorPersonalVehicle = '';
      }
    }
    tutorTrainingAndRetrainingTypeChange(event, index){
      this.listTutorTrainingAndRetrainingType[index].checked = event;
    }
    tutorTrainingAndRetrainingChange(event, index){
      this.listTutorTrainingAndRetraining[index].checked = event;
      if(this.listTutorTrainingAndRetraining[index].isRequiredNote &&  !this.listTutorTrainingAndRetraining[index].checked){
        this.disabilitySurvey.tutorTrainingAndRetrainingNote = '';
      }
    }
    ////////////////////////////
}
